"use strict";
var objectProto = Object.prototype;
var nativeObjectToString = objectProto.toString;
function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;
//# sourceMappingURL=_objectToString.js.map